import { render, staticRenderFns } from "./CryptoWithdrawForm.vue?vue&type=template&id=dddde3f8"
import script from "./CryptoWithdrawForm.vue?vue&type=script&lang=js"
export * from "./CryptoWithdrawForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports